module.exports = __webpack_public_path__ + "resources/img/img-manufacturing-fems-m.f37691c17f76cadd8a51433733dcf68b.png";